export default __webpack_public_path__ + "static/media/arturo.bed4db0f.jpg";